import React, { useMemo } from "react";
import { KeyboardContainer } from "../styled/common";

const MAX_LENGTH = {
  tel: 11,
  password: 4,
  passwordConfirm: 4,
};

const SPECIAL_KEYS = {
  BACKSPACE: "지우기",
};

const NumberKeyboard = ({ type = "", inputValue = "", handleChangeInput }) => {
  const currentValue = inputValue || "";
  const limit = MAX_LENGTH[type] ?? 999;

  const keys = useMemo(() => {
    const numberKeys = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

    if (type === "tel") {
      return [...numberKeys, SPECIAL_KEYS.BACKSPACE, "0"];
    }

    return [...numberKeys, SPECIAL_KEYS.BACKSPACE, "0"];
  }, [type]);

  const updateValue = (nextValue) => {
    handleChangeInput(type, nextValue);
  };

  const handleBackspace = () => {
    if (type === "tel") {
      if (currentValue.length <= 3) return;
      updateValue(currentValue.slice(0, -1));
      return;
    }

    updateValue(currentValue.slice(0, -1));
  };

  const appendValue = (appendText) => {
    if (type === "tel") {
      if (currentValue.length >= 11) return;
      updateValue(`${currentValue}${appendText}`.slice(0, 11));
      return;
    }

    updateValue(`${currentValue}${appendText}`.slice(0, limit));
  };

  const handleKeyPress = (key) => {
    if (key === SPECIAL_KEYS.BACKSPACE) {
      handleBackspace();
      return;
    }

    appendValue(key);
  };

  const getBtnClass = (key) => {
    if (key === SPECIAL_KEYS.BACKSPACE) return "function ghost";
    if (key === "0") return "zero";
    return "number";
  };

  return (
    <KeyboardContainer>
      <div className={`keyboard ${type === "tel" ? "telKeyboard" : "defaultKeyboard"}`}>
        {keys.map((key) => (
          <button
            key={key}
            type="button"
            className={getBtnClass(key)}
            onClick={() => handleKeyPress(key)}
          >
            {key}
          </button>
        ))}
      </div>
    </KeyboardContainer>
  );
};

export default NumberKeyboard;